export const CallRecordingConfigurationRepositoryToken = Symbol(
  'CallRecordingConfigurationRepositoryToken',
);
